module.exports = __webpack_public_path__ + "images/small-business-bus.png";